import { computed, ref } from 'vue'

import type { Ref, ComputedRef } from 'vue'
import type { MultiselectSearchOption } from '@shared/ui/fields'

import { useListsStore } from '@shared/model'

interface FilterTaskTypeOptions {
  initial: string[]
}

interface FilterTaskTypeReturn {
  options: ComputedRef<MultiselectSearchOption[]>
  query: Ref<string[]>
  initialValue: ComputedRef<string[]>
  handleSelected: (selected: MultiselectSearchOption[]) => void
}

export const useFilterTaskType = ({ initial }: FilterTaskTypeOptions): FilterTaskTypeReturn => {
  const listsStore = useListsStore()

  const query = ref<string[]>(initial)

  const options = computed<MultiselectSearchOption[]>(() => {
    const taskTypes = listsStore.getTasksKanbanList?.task_type ?? {}

    return Object.entries(taskTypes).map(([key, text]) => ({
      id: key,
      value: key,
      text,
      selected: query.value.includes(key),
    }))
  })

  const initialValue = computed<string[]>(() => {
    return options.value
      .filter(option => option.selected)
      .map(option => option.text)
  })

  const handleSelected = (selected: MultiselectSearchOption[]): void => {
    query.value = selected.map(option => String(option.value))
  }

  return {
    options,
    query,
    initialValue,
    handleSelected,
  }
}
